import React from 'react';
import { List, Typography, Button, Flex, theme, Grid } from 'antd';
import { WidgetDataItem } from '../../../types';

const { Text, Paragraph } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;

// Tipos
interface ChannelCardProps {
  widgetData: WidgetDataItem & {
    icon: React.ReactNode;
    onClick: () => void
  };
  children?: React.ReactNode;
  headerAction?: React.ReactNode;
}

// Componente de tarjeta de canal individual
const ChannelCardItem: React.FC<{
  item: ChannelCardProps['widgetData'];
  isMobile: boolean;
  token: any;
  headerAction?: React.ReactNode;
}> = ({ item, isMobile, token, headerAction }) => (
  <List.Item>
    <Flex
      justify="space-between"
      align= "flex-start"
      style={{ width: '100%' }}
      vertical={isMobile}
      gap={isMobile ? token.marginSM : 0}
    >
      <Flex
        align="start"
        gap={token.marginMD}
        style={{ width: isMobile ? '100%' : 'auto' }}
      >
        {item.icon}
        <ChannelCardContent item={item} />
      </Flex>
      {/* Mostrar headerAction o ChannelCardAction */}
      {headerAction ? (
        <div style={{ width: isMobile ? '100%' : 'auto' }}>
          {headerAction}
        </div>
      ) : (
        <ChannelCardAction item={item} isMobile={isMobile} />
      )}
    </Flex>
  </List.Item>
);

// Componente para el contenido de la tarjeta
const ChannelCardContent: React.FC<{ item: ChannelCardProps['widgetData'] }> = ({ item }) => (
  <Flex vertical gap={'8px'}>
    <Text strong style={{ fontSize: '17px' }}>{item.title}</Text>
    <Paragraph type="secondary" style={{ margin: 0 }}>
      {item.description}
    </Paragraph>
    <Text type="secondary">Setup: {item.setup}</Text>
  </Flex>
);

// Componente para el botón de acción
const ChannelCardAction: React.FC<{ 
  item: ChannelCardProps['widgetData'];
  isMobile: boolean;
}> = ({ item, isMobile }) => {
  // Solo mostrar el botón para WhatsApp, no para Website Widget
  if (item.iconType === 'whatsapp') {
    return (
      <Button onClick={item.onClick} style={{ width: isMobile ? '100%' : 'auto' }}>
        {item.action}
      </Button>
    );
  }
  return null;
  
  // Código original comentado:
  // <Button onClick={item.onClick} style={{ width: isMobile ? '100%' : 'auto' }}>
  //   {item.action}
  // </Button>
};

// Componente principal
export default function MyAssistantChannelCard({ widgetData, children, headerAction }: ChannelCardProps) {
  const { token } = useToken();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <>
      <List
        itemLayout="horizontal"
        dataSource={[widgetData]}
        renderItem={(item) => (
          <ChannelCardItem
            item={item}
            isMobile={isMobile}
            token={token}
            headerAction={headerAction}
          />
        )}
      />
      {children}
    </>
  );
} 